export default function comparePhoneNumbers(num1, num2) {
  // Remove all non-numeric characters (like spaces, parentheses, dashes, etc.)
  const cleanNum1 = num1.replace(/\D/g, '');
  const cleanNum2 = num2.replace(/\D/g, '');

  // Compare the cleaned phone numbers
  return cleanNum1 === cleanNum2;
}
